import { useState, useEffect } from 'react';

import {
  useAppwatchSelector,
  useAppwatchDispatch,
  PaymentAnalysisActions,
} from '@wajeez-web/stores/appwatch';
import { Card } from '@wajeez-web/components/ui';
import { ChartDisplay } from '@wajeez-web/components/ui';
import { ChartHeader } from '../ChartHeader';
import { Select } from 'antd';
import { ChartsProps } from '../types';

const BreakDownofPremiumByPurchaseSurceChart = ({ dates }: ChartsProps) => {
  const dispatch = useAppwatchDispatch();
  const {
    breakDownofPremiumByPurchaseSurce,

    breakDownofPremiumByPurchaseSurceStatus,
  } = useAppwatchSelector((c) => c.paymentAnalysis);

  const [subscriptionPeriod, setSubscriptionPeriod] = useState<string>('');

  useEffect(() => {
    breakDownofPremiumByPurchaseSurce.length &&
      setSubscriptionPeriod(
        breakDownofPremiumByPurchaseSurce[0].subscription_Period || ''
      );
  }, [breakDownofPremiumByPurchaseSurce]);

  useEffect(() => {
    dispatch(
      PaymentAnalysisActions.getBreakdownOfPremuimsByPurchesSourceAsync({
        fromDate: dates[0].toISOString(),
        toDate: dates[1].toISOString(),
      })
    );
  }, [dates]);

  return (
    <div className="col-span-2 md:col-span-1">
      {' '}
      <Card>
        <div className="space-y-2 min-h-[400px]">
          <div className="flex flex-row justify-between">
            <ChartHeader
              title="Break Down of Premium By Purchase Source"
              dates={dates}
            />

            <div>
              <Select
                className="w-32"
                value={subscriptionPeriod}
                onChange={(e) => {
                  setSubscriptionPeriod(e);
                }}
                options={breakDownofPremiumByPurchaseSurce
                  .map((d) => d.subscription_Period)
                  .filter(function (item, pos, self) {
                    return self.indexOf(item) == pos;
                  })
                  .map((d) => ({
                    value: d,
                    label: d,
                  }))}
              />
            </div>
          </div>

          <ChartDisplay
            loading={breakDownofPremiumByPurchaseSurceStatus === 'loading'}
            chartType="pie"
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            labels={
              breakDownofPremiumByPurchaseSurce
                .filter((d) => d.subscription_Period === subscriptionPeriod)
                .map((d) => d.purchase_Source_Type || '') || []
            }
            seriesData={breakDownofPremiumByPurchaseSurce
              .filter((ele) => ele.subscription_Period === subscriptionPeriod)
              .map((d) => d.count || 0)}
          />
        </div>
      </Card>
    </div>
  );
};

export default BreakDownofPremiumByPurchaseSurceChart;
